import errorRes from '../utils/errorRes';
import API from './baseApi';

export const postSendMessage = async ({ receiverId, message }) => {
	try {
		const response = await API.post(`/admin/message/${receiverId}`, { message });

		return response.data;
	} catch (error) {
		throw errorRes(error);
	}
};

export const getConversation = async () => {
	try {
		const response = await API.get(`/admin/conversation`);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const getMessagesByUser = async (conversationId) => {
	try {
		const response = await API.get(`/admin/message/${conversationId}`);
		return response.data;
	} catch (error) {
		throw errorRes(error);
	}
};

export const getConversationId = async (recieverId) => {
	try {
		const response = await API.get(`/admin/conversation/${recieverId}`);
		return response.data;
	} catch (error) {
		throw errorRes(error);
	}
};

export const getUnreadMessage = async (receiver) => {
	try {
		const response = await API.get(`/admin/conversation/unread/${receiver}`);

		return response.data;
	} catch (error) {
		throw errorRes(error);
	}
};
